import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/lan-ri-logo.png")